import React from "react";
import allRooms from "../../images/Full-room-scaled.jpg"
import roomA from "../../images/Room-A.jpg"
import roomB from "../../images/Room-B.jpg"
import roomC from "../../images/Room-C.jpg"
import kitchen from "../../images/output-1.jpg"
// import { MarkersPlugin } from "@photo-sphere-viewer/markers-plugin"
import { ReactPhotoSphereViewer } from "react-photo-sphere-viewer"
import Prose from "../utility/prose";

const VirtualTour = () => {

    return (
        <Prose>
            <div className="text-center">
                <h2>Virtually tour the rooms for rent</h2>
                <div className="iframe-16by9-wrapper">
                    <ReactPhotoSphereViewer
                        src={allRooms}
                        defaultZoomLvl={0}
                        defaultYaw={1.7}
                        width={"100%"}
                        containerClass="iframe-rounded w-full aspect-video overflow-hidden"
                        littlePlanet={false}
                        hideNavbarButton={false}
                    />
                </div>
                <p>All 3 Rooms</p>
            </div>
            <hr />
            <div className="md:flex gap-8 text-center">
                <div className="w-full">
                    <div className="iframe-16by9-wrapper">
                        <ReactPhotoSphereViewer
                            src={roomA}
                            defaultZoomLvl={0}
                            defaultYaw={0.7}
                            width={"100%"}
                            containerClass="iframe-rounded w-full aspect-video overflow-hidden"
                            littlePlanet={false}
                            hideNavbarButton={false}
                        />
                    </div>
                    <p>Room A</p>
                </div>
                <div className="w-full">
                    <div className="iframe-16by9-wrapper">
                        <ReactPhotoSphereViewer
                            src={roomB}
                            defaultZoomLvl={0}
                            defaultYaw={1.9}
                            width={"100%"}
                            containerClass="iframe-rounded w-full aspect-video overflow-hidden"
                            littlePlanet={false}
                            hideNavbarButton={false}
                        />
                    </div>
                    <p>Room B</p>
                </div>
                <div className="w-full">
                    <div className="iframe-16by9-wrapper">
                        <ReactPhotoSphereViewer
                            src={roomC}
                            defaultZoomLvl={0}
                            defaultYaw={-1.7}
                            width={"100%"}
                            containerClass="iframe-rounded w-full aspect-video overflow-hidden"
                            littlePlanet={false}
                            hideNavbarButton={false}
                        />
                    </div>
                    <p>Room C</p>
                </div>
            </div>
            <hr />
            <div className="text-center">
                <div className="iframe-16by9-wrapper">
                    <ReactPhotoSphereViewer
                        src={kitchen}
                        defaultZoomLvl={0}
                        defaultYaw={0}
                        width={"100%"}
                        containerClass="iframe-rounded w-full aspect-video overflow-hidden"
                        littlePlanet={false}
                        hideNavbarButton={false}
                    />
                </div>
                <p>Kitchen Space</p>
                <hr />
                <h2>Additional Photos</h2>
            </div>
        </Prose>
    )
}

export default VirtualTour
